import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/da0kn0u859p3u981e3s0";

type Status = "idle" | "success" | "error";

export default function ContactForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);

    const honeypot = String(data.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("感谢你的留言！我们会尽快与您联系。");
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key !== "company_alt" && value !== "") payload.append(key, String(value));
    });

    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const ok = res.ok && parsed?.code === "OK";
      if (ok) {
        setStatus("success");
        setMessage("感谢你的留言！我们会尽快与您联系。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  }

  return (
    <form data-readdy-form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label htmlFor="cf-name" className="mb-1.5 block text-sm font-medium text-foreground-800">你的称呼</label>
          <input id="cf-name" type="text" name="name" required placeholder="如何称呼你" autoComplete="name" className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200" />
        </div>
        <div>
          <label htmlFor="cf-email" className="mb-1.5 block text-sm font-medium text-foreground-800">邮箱地址</label>
          <input id="cf-email" type="email" name="email" required placeholder="you@example.com" autoComplete="email" className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200" />
        </div>
      </div>
      <div>
        <label htmlFor="cf-subject" className="mb-1.5 block text-sm font-medium text-foreground-800">留言主题</label>
        <input id="cf-subject" type="text" name="subject" placeholder="想聊点什么？合作、反馈或推荐" className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200" />
      </div>
      <div>
        <label htmlFor="cf-message" className="mb-1.5 block text-sm font-medium text-foreground-800">留言内容</label>
        <textarea id="cf-message" name="message" required rows={5} maxLength={500} placeholder="写下你想说的话（最多 500 字）" className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200" />
      </div>
      {/* 蜜罐字段，用于拦截自动提交的机器人 */}
      <input
        type="text"
        name="company_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      {status === "success" && (
        <p role="status" className="flex items-center gap-1.5 text-sm text-accent-700">
          <i className="ri-checkbox-circle-line" aria-hidden="true"></i>{message}
        </p>
      )}
      {status === "error" && (
        <p role="alert" className="flex items-center gap-1.5 text-sm text-primary-700">
          <i className="ri-error-warning-line" aria-hidden="true"></i>{message}
        </p>
      )}
      <div>
        <button type="submit" className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600">
          提交留言
        </button>
      </div>
    </form>
  );
}